import mycarsSrpVdp from './utils/mycarsSrpVdp';

export default {
	events: {
		'ddc.link.generic': [...mycarsSrpVdp.events['ddc.link.generic']],
		widgetUserEvent: [
			{
				logic: {
					widgetName: 'ws-inv-listing',
					mustInclude: {
						'eventData.element': 'Photo carousel',
						'eventData.result': 'Move to',
						'eventData.action': 'clicked'
					}
				},
				payload: {
					event: 'asc_media_interaction',
					affiliation: 'dealer_dot_com',
					media_type: 'gallery',
					link_url: '{{EMPTYSTRING}}',
					creative_name: '{{EMPTYSTRING}}',
					event_action: 'click',
					shared: [
						'[[mapping.configuration.sharedPayloads.sharedProps]]',
						'[[mapping.configuration.sharedPayloads.vehicleData]]',
						{
							logic: {
								mustInclude: {
									'eventData.element': 'next'
								}
							},
							payload: {
								event_action_result: 'increase'
							}
						},
						{
							logic: {
								mustInclude: {
									'eventData.element': 'previous'
								}
							},
							payload: {
								event_action_result: 'decrease'
							}
						}
					]
				}
			},
			{
				logic: ({ eventData: { isWindowStickerLink } }) =>
					isWindowStickerLink,
				payload: ({ eventData: { elementCTA, url } }) => ({
					shared: [
						'[[mapping.configuration.sharedPayloads.sharedProps]]',
						'[[mapping.configuration.sharedPayloads.vehicleData]]'
					],
					element_text: elementCTA,
					element_type: 'item_details',
					event: 'asc_cta_interaction',
					event_action: 'click',
					event_action_result: 'redirect',
					link_url: url
				})
			}
		]
	}
};
